import React, { useState, useEffect } from 'react';
import CommonInput from '../../../../components/Dashboard-res/CommonComponent/CommonInput';
import { useFormikContext } from 'formik';
import Styles from '../companyDetails.module.css';
import RadioButton from '../../../../components/Dashboard-res/CommonComponent/RadioButton';
import CommonSelect from '../../../../components/Dashboard-res/CommonComponent/CommonSelect';
import {
  getStatesList,
  addNewBusinessDirector,
  getSelpEmployeedDetails
} from '../../../../common/constants/api';
import * as _ from 'lodash';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import CommonDatePicker from '../../../../components/Dashboard-res/CommonComponent/CommonDatePicker';
import moment from 'moment';
import PopUp from '../../../../common/components/PopUp/PopUp';
import { getApplicantionInfo } from '../../../../common/utils/applicantionInfo';

const {
  input_type,
  fit_content,
  fit_content_medium,
  directorInputBox
} = Styles;
const inputDivClass = 'xxl:my-6 my-2 mx-2 w-full xl:w-4/12';

const commonInputEffect = {
  height: '52px',
  maxWidth: '100%',
  minWidth: '200px'
};
const comonSelectContainerEffect = {
  height: '52px',
  marginBottom: '0px',
  fontSize: '40px'
};
const commonDropDownStles = {
  top: '52px',
  color: 'rgba(0,0,0,0.87)',
  fontSize: '16px',
  backgroundColor: '#fff',
  alignItems: 'center',
  fontFamily: 'Roboto',
  fontWeight: 400
};
const selectCommonDisplay = {
  fontSize: '14px',
  padding: '0 25px'
};

let curr_date = moment().year();
const AddDirectors = ({ setActionOnDirectorPage }) => {
  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading...');
  const [show, setShow] = useState(false);
  const [senpID, setSEPId] = useState(false);

  useEffect(() => {
    setType('loading');
    setText('Please Wait...');
    setShow(true);
    getSelpEmployeedDetails(
      getApplicantionInfo().leadId,
      getApplicantionInfo().leadApplicantId
    )
      .then(res => {
        if (res.error) {
          throw new Error(res);
        }
        setShow(false);
        if (_.get(res, 'selfEmployedId', false)) {
          setSEPId(res.selfEmployedId);
        } else {
          throw new Error(res);
        }
      })
      .catch(error => {
        setType('fail');
        setText(_.get(error, 'response.data.message', 'something went wrong'));
        setShow(true);
      });
  }, []);
  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Required'),
    dinNo: Yup.string().required('Required'),
    pan: Yup.string()
      .required('Required')
      .matches(
        '[A-Z]{3}[ABCFGHLJPTF]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}',
        'PAN no. Invalid'
      ),
    designation: Yup.string().required('Required'),
    isDscReg: Yup.string().required('Required'),
    date: Yup.object().shape({
      value: Yup.string().required('required')
    }),
    month: Yup.object().shape({
      value: Yup.string().required('required')
    }),
    year: Yup.object().shape({
      value: Yup.string().required('required')
    }),
    expiry_year: Yup.object().shape({
      value: Yup.string().required('required')
    }),
    exipry_month: Yup.object().shape({
      value: Yup.string().required('required')
    }),
    exipry_date: Yup.object().shape({
      value: Yup.string().required('required')
    }),
    address: Yup.string()
      .required('Required')
      .min('20', 'Too short!')
  });

  return (
    <Formik
      initialValues={{
        name: '',
        dinNo: '',
        pan: '',
        designation: '',
        doa: '',
        edate: '',
        address_line_1: '',
        address_line_2: '',
        city: '',
        state: { label: 'select State', value: '' },
        pincode: '',
        isDscReg: 'yes',
        date: {
          value: '',
          label: 'Date'
        },
        month: {
          value: '',
          label: 'Month'
        },
        year: {
          value: curr_date,
          label: curr_date
        },
        exipry_date: {
          value: '',
          label: 'Date'
        },
        exipry_month: {
          value: '',
          label: 'Month'
        },
        expiry_year: {
          value: curr_date,
          label: curr_date
        }
      }}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting }) => {
        setActionOnDirectorPage('viewDir');
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        setFieldTouched,
        setFieldError,
        validateForm
      }) => {
        const handleDinNumber = e => {
          if (
            !isNaN(_.get(e, 'target.value', 0)) &&
            _.get(e, 'target.value', 0).length <= 8
          )
            handleChange(e);
        };
        const submitValues = () => {
          setType('loading');
          setText('Submitting Please Wait...');
          setShow(true);
          let body = {
            fullName: values.name,
            din: values.dinNo,
            pan: values.pan,
            designation: values.designation,
            appointmentDate: `${values.year.value}-${
              values.month.value.length == 1
                ? '0' + values.month.value
                : values.month.value
            }-${values.date.value}`,
            dscRegisteredExpiryDate: `${values.expiry_year.value}-${
              values.exipry_month.value.length == 1
                ? '0' + values.exipry_month.value
                : values.exipry_month.value
            }-${values.exipry_date.value}`,
            dscRegistered: values.isDscReg == 'yes' ? true : false,
            address: values.address,
            selfEmployedId: senpID
          };
          addNewBusinessDirector(
            getApplicantionInfo().leadId,
            getApplicantionInfo().leadApplicantId,
            body
          )
            .then(res => {
              if (res.error) {
                throw new Error(res);
              }
              setShow(false);
              handleSubmit();
            })
            .catch(error => {
              setType('fail');
              setText(
                _.get(error, 'response.data.message', 'something went wrong')
              );
              setShow(true);
            });
        };
        const handleSubmition = () => {
          validateForm().then(res => {
            if (Object.keys(res).length == 0) {
              submitValues();
            } else {
              handleSubmit();
            }
          });
        };

        return (
          <Form>
            <div className="w-full mx-auto my-4 bg-navy-600 md:bg-white">
              <div className="w-11/12 md:w-10/12 mx-auto">
                <div className="w-full flex">
                  <div className="font-roboto font-medium text-base text-black-850 my-4 mx-2 ">
                    Add Director Details
                  </div>
                  <div
                    className="font-roboto font-medium text-base text-green-600 my-4 mx-2 ml-auto float-right cursor-pointer"
                    onClick={e => setActionOnDirectorPage('viewDir')}
                  >
                    View All Directors
                  </div>
                </div>
                <div className="w-full flex flex-wrap ">
                  <div
                    className={`${inputDivClass} ${directorInputBox} ${fit_content_medium}`}
                  >
                    <CommonInput
                      name="name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.name}
                      stylesContainer={commonInputEffect}
                      legendName="Full Name"
                      error={touched.name && errors.name}
                      errorMsg={errors.name}
                      touched={touched.name}
                    />
                  </div>
                  <div
                    className={`${inputDivClass} ${directorInputBox} ${fit_content_medium} `}
                  >
                    <CommonInput
                      name="dinNo"
                      onChange={e => handleDinNumber(e)}
                      onBlur={handleBlur}
                      value={values.dinNo}
                      stylesContainer={commonInputEffect}
                      legendName="DIN Number"
                      error={touched.dinNo && errors.dinNo}
                      errorMsg={errors.dinNo}
                      touched={touched.dinNo}
                    />
                  </div>{' '}
                  <div
                    className={`${inputDivClass} ${directorInputBox} ${fit_content_medium} `}
                  >
                    <CommonInput
                      name="pan"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.pan}
                      stylesContainer={commonInputEffect}
                      legendName="PAN"
                      error={touched.pan && errors.pan}
                      errorMsg={errors.pan}
                      touched={touched.pan}
                    />
                  </div>{' '}
                  <div
                    className={`${inputDivClass} ${directorInputBox} ${fit_content_medium}`}
                  >
                    <CommonInput
                      name="designation"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.designation}
                      stylesContainer={commonInputEffect}
                      legendName="Designation"
                      error={touched.designation && errors.designation}
                      errorMsg={errors.designation}
                      touched={touched.designation}
                    />
                  </div>{' '}
                  <div
                    className={`xxl:my-0 my-2 mx-2 w-full xl:w-6/12 ${directorInputBox}  `}
                  >
                    <div className="text-black-600 font-roboto font-normal text-xs pb-2">
                      Date Of Appointmemt
                    </div>
                    <CommonDatePicker
                      styleHeight={{ height: '52px' }}
                      onChangeMonth={(value, isValidDate) => {
                        setFieldValue('month', value, true);

                        setFieldTouched('month', true, false);
                        if (!isValidDate) {
                          setFieldValue(
                            'date',
                            {
                              value: '',
                              label: 'Date'
                            },
                            true
                          );
                        }
                      }}
                      onChangeYear={(value, isValidDate) => {
                        setFieldValue('year', value, true);
                        setFieldTouched('year', true, false);

                        if (!isValidDate) {
                          setFieldValue(
                            'date',
                            {
                              value: '',
                              label: 'Date'
                            },
                            true
                          );
                        }
                      }}
                      onChangeDate={value => {
                        setFieldValue('date', value, true);
                        setFieldTouched('date', true, false);
                      }}
                      valueMonth={values.month}
                      valueYear={values.year}
                      valueDate={values.date}
                      errorYear={
                        touched.year && _.get(errors, 'year.value', false)
                      }
                      touchedYear={touched.year}
                      onBlurYear={() => {
                        setFieldTouched('year', true, true);
                      }}
                      errorMonth={
                        touched.month && _.get(errors, 'month.value', false)
                      }
                      touchedMonth={touched.month}
                      onBlurMonth={() => {
                        setFieldTouched('month', true, true);
                      }}
                      // errors.date.value
                      errorDate={
                        touched.date && _.get(errors, 'date.value', false)
                      }
                      touchedDate={touched.date}
                      onBlurDate={() => {
                        setFieldTouched('date', true, true);
                      }}
                    />
                  </div>
                  <div
                    className={`mx-2 xxl:my-0 my-2 w-full xl:w-6/12 ${directorInputBox}  `}
                  >
                    <div className="text-black-600 font-roboto font-normal text-xs pb-2">
                      {' '}
                      Expiry date of DSC registered
                    </div>

                    <CommonDatePicker
                      styleHeight={{ height: '52px' }}
                      onChangeMonth={(value, isValidDate) => {
                        setFieldValue('exipry_month', value, true);

                        setFieldTouched('exipry_month', true, false);
                        if (!isValidDate) {
                          setFieldValue(
                            'exipry_month',
                            {
                              value: '',
                              label: 'Date'
                            },
                            true
                          );
                        }
                      }}
                      onChangeYear={(value, isValidDate) => {
                        setFieldValue('expiry_year', value, true);
                        setFieldTouched('expiry_year', true, false);

                        if (!isValidDate) {
                          setFieldValue(
                            'expiry_year',
                            {
                              value: '',
                              label: 'Date'
                            },
                            true
                          );
                        }
                      }}
                      onChangeDate={value => {
                        setFieldValue('exipry_date', value, true);
                        setFieldTouched('exipry_date', true, false);
                      }}
                      valueMonth={values.exipry_month}
                      valueYear={values.expiry_year}
                      valueDate={values.exipry_date}
                      errorYear={
                        touched.expiry_year &&
                        _.get(errors, 'expiry_year.value', false)
                      }
                      touchedYear={touched.expiry_year}
                      onBlurYear={() => {
                        setFieldTouched('expiry_year', true, true);
                      }}
                      errorMonth={
                        touched.exipry_month &&
                        _.get(errors, 'exipry_month.value', false)
                      }
                      touchedMonth={touched.exipry_month}
                      onBlurMonth={() => {
                        setFieldTouched('exipry_month', true, true);
                      }}
                      // errors.date.value
                      errorDate={
                        touched.exipry_month &&
                        _.get(errors, 'exipry_month.value', false)
                      }
                      touchedDate={touched.exipry_month}
                      onBlurDate={() => {
                        setFieldTouched('exipry_date', true, true);
                      }}
                    />
                  </div>
                </div>
                <div className="w-full px-2 mt-3">
                  <div className="font-roboto font-normal text-base text-black-400 ">
                    DSC registered
                  </div>
                  <div className="">
                    <div className="w-full flex  py-3 mt-1">
                      <div className="flex flex-row ">
                        <RadioButton
                          name="isDscReg"
                          value={values.isDscReg == 'yes' ? true : false}
                          checked={values.isDscReg == 'yes' ? true : false}
                          onChange={e => {
                            handleChange(e), setFieldValue('isDscReg', 'yes');
                          }}
                          onBlur={handleBlur}
                        />
                        <p className="font-roboto font-normal text-grey-2000 md:px-3 mr-auto px-1">
                          Yes
                        </p>
                      </div>
                      <div className="mr-auto flex md:ml-10 flex-row ml-16 ">
                        <RadioButton
                          name="isDscReg"
                          value={values.isDscReg == 'no' ? true : false}
                          checked={values.isDscReg == 'no' ? true : false}
                          onChange={e => {
                            handleChange(e), setFieldValue('isDscReg', 'no');
                          }}
                          onBlur={handleBlur}
                        />
                        <p className="font-roboto font-normal text-grey-2000 md:px-3  mr-auto px-1">
                          No
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-full">
                  <div className="font-roboto font-normal text-base text-black-400 my-4 mx-2">
                    Director Address
                  </div>

                  <AddressField
                    values={values}
                    errors={errors}
                    touched={touched}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    handleSubmit={handleSubmit}
                    isSubmitting={isSubmitting}
                    setFieldValue={setFieldValue}
                    setFieldTouched={setFieldTouched}
                    setFieldError={setFieldError}
                    validateForm={validateForm}
                  />
                </div>
              </div>
              <button
                type="button"
                className="submitButton font-roboto text-white text-base w-48"
                onClick={handleSubmition}
              >
                NEXT
              </button>
            </div>
            <PopUp type={type} text={text} setShow={setShow} show={show} />
          </Form>
        );
      }}
    </Formik>
  );
};

export default AddDirectors;

const AddressField = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  isSubmitting,
  setFieldValue,
  setFieldTouched,
  setFieldError,
  validateForm
}) => {
  const [stateList, setStateList] = useState([]);
  useEffect(() => {
    getStatesList()
      .then(res => {
        let dict = {},
          total_list = [];
        for (let i = 0; i < res.length; i++) {
          dict = {};
          dict['label'] = res[i].name;
          dict['value'] = res[i].id;
          total_list.push(dict);
        }
        setStateList(total_list);
      })
      .catch(error => {});
  }, []);
  const handlePinCode = (err, pincodeData) => {
    if (!err && pincodeData) {
      setFieldValue('pinCoderesolved', true);
      setFieldValue('pincodeCity', pincodeData.District),
        setFieldValue('pincodeState', pincodeData.State);
    } else {
      setFieldError('pincode', 'Pincode is not valid');
    }
  };
  const inputAddressClass = 'xl:w-6/12 px-3 my-4 w-full';

  return (
    <div className="md:w-10/12 w-full block">
      <textarea
        name="address"
        value={values.address}
        onChange={handleChange}
        className={`w-6/12 mr-auto border rounded h-full mx-2 rounded bg-white  
        hover:border hover:border-green-600 border ${
          errors.address ? 'border-red-200' : 'border-grey-350'
        } p-5`}
        style={{ minHeight: '150px' }}
      />
      {errors.address ? (
        <div className="font-roboto text-left mx-2 font-normal text-sm text-red-300">
          {errors.address}
        </div>
      ) : null}
    </div>
  );
};
